// Takip numarasi + kargo firmasi alanlari. Firma listeden secilir ya da
// yazilir; takip numarasi girilince bicimden tahmin edilir (elle secim ezilmez).

import { useEffect, useId, useRef } from "react";
import { CARRIERS, guessCarrier, lastCarrier } from "../../lib/carriers";

export default function TrackingFields({
  code, carrier, onCode, onCarrier, compact = false,
}: {
  code: string;
  carrier: string;
  onCode: (v: string) => void;
  onCarrier: (v: string) => void;
  compact?: boolean;
}) {
  const listId = useId();
  // Kullanici firmayi elle degistirdiyse tahmin onu ezmez
  const manual = useRef(false);

  useEffect(() => {
    if (!carrier) {
      const last = lastCarrier();
      if (last) onCarrier(last);
    }
    // yalnizca ilk acilista
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCode = (v: string) => {
    onCode(v);
    const guess = guessCarrier(v);
    if (guess && !manual.current) onCarrier(guess);
  };

  const input = "rounded-lg border border-gray-200 px-2.5 py-1.5 text-sm";
  const codeEl = (
    <input
      value={code}
      onChange={(e) => handleCode(e.target.value)}
      placeholder="Takip numarası"
      className={compact ? `${input} w-52` : `${input} w-full`}
    />
  );
  const carrierEl = (
    <>
      <input
        list={listId}
        value={carrier}
        onChange={(e) => { manual.current = true; onCarrier(e.target.value); }}
        placeholder="Kargo firması"
        className={compact ? `${input} w-44` : `${input} w-full`}
      />
      <datalist id={listId}>
        {CARRIERS.map((c) => <option key={c} value={c} />)}
      </datalist>
    </>
  );

  if (compact) return <>{codeEl}{carrierEl}</>;
  return (
    <>
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700">Takip Numarası</label>
        {codeEl}
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700">Kargo Firması</label>
        {carrierEl}
        <p className="mt-1 text-xs text-gray-400">Takip numarasından tahmin edilir; listeden seçebilir ya da yazabilirsin.</p>
      </div>
    </>
  );
}
